import React, { useRef, useEffect } from 'react';
import { useLocation, Link } from 'react-router-dom';
import './OurMenus.css';
import { Beverages, Staters, wazwan, indian, veg} from '../MenuData';

const OurMenus = () => {
    const refs = {
        'beverages': useRef(null),
        'starters': useRef(null),
        'main-course': useRef(null),
        'indian-delicacies': useRef(null),
        'vegetarian-specialties': useRef(null),
    };

    const location = useLocation();

    useEffect(() => {
        const section = location.pathname.split('/').pop();
        if (refs[section] && refs[section].current) {
            setTimeout(() => {
                refs[section].current.scrollIntoView({ behavior: 'smooth' });
            }, 100);
        }
    }, [location]);

    const scrollToSection = (e, sectionRef) => {
        e.preventDefault();
        if (sectionRef.current) {
            sectionRef.current.scrollIntoView({ behavior: 'smooth' });
        }
    };

    return (
        <>
            <div className="breakfast-menu">
                <nav className="menu-nav mt-5">
                    <ul>
                        <li><Link to="/menu/starters" onClick={(e) => scrollToSection(e, refs['starters'])}>Starters</Link></li>
                        <li><Link to="/menu/main-course" onClick={(e) => scrollToSection(e, refs['main-course'])}>Main Course</Link></li>
                        <li><Link to="/menu/beverages" onClick={(e) => scrollToSection(e, refs['beverages'])}>Beverages</Link></li>
                        <li><Link to="/menu/indian-delicacies" onClick={(e) => scrollToSection(e, refs['indian-delicacies'])}>Indian Delicacies</Link></li>
                        <li><Link to="/menu/vegetarian-specialties" onClick={(e) => scrollToSection(e, refs['vegetarian-specialties'])}>Vegetarian Specialties</Link></li>
                    </ul>
                </nav>


                <div ref={refs['starters']} className='starters'>
                    <div className="image-container1">
                        <div className="overlay1"></div>
                        <img src="../images/Staters/starters-bg.jpg" alt="Starters" />
                        <h2>Starters</h2>
                    </div>
                    <div className="starters-menu mt-5 mb-5">
                        {Staters.map(item => (
                            <Link to={`/menu-item/${item.id}`} key={item.id} className="food-item1">
                                <img src={item.image} alt={item.name} className="food-image1" />
                                <div className="item-info1 mt-4">
                                    <h3>{item.name}</h3>
                                </div>
                                <p id='desc'>{item.description}</p>
                            </Link>
                        ))}
                    </div>
                </div>


                <div ref={refs['main-course']} className='wazwan'>
                    <div className="image-container1">
                        <div className="overlay1"></div>
                        <img src="../images/background-about.webp" alt="Wazwan Main Course" />
                        <h2>Wazwan Main Course</h2>
                    </div>
                    <div className="wazwan-menu mt-5 mb-5">
                        {wazwan.map(item => (
                            <Link to={`/menu-item/${item.id}`} key={item.id} className="food-item">
                                <img src={item.image} alt={item.name} className="food-image" />
                                <div className="item-info mt-4">
                                    <h3>{item.name}</h3>
                                </div>
                                <p id='desc'>{item.description}</p>
                            </Link>
                        ))}
                    </div>
                </div>


                <div ref={refs['beverages']} className='beverages'>
                    <div className="image-container1">
                        <div className="overlay1"></div>
                        <img src="../images/beverages/beverage-bg.jpg" alt="Beverages" />
                        <h2>Beverages</h2>
                    </div>
                    <div className="beverages-menu mt-5 mb-5">
                        {Beverages.map(item => (
                            <Link to={`/menu-item/${item.id}`} key={item.id} className="food-item1">
                                <img src={item.image} alt={item.name} className="food-image1" />
                                <div className="item-info1 mt-4">
                                    <h3>{item.name}</h3>
                                </div>
                                <p id='desc'>{item.description}</p>
                            </Link>
                        ))}
                    </div>
                </div>



                <div ref={refs['indian-delicacies']} className='indian-delicious'>
                    <div className="image-container1">
                        <div className="overlay1"></div>
                        <img src="../images/indian/indian-bf.jpg" alt="Indian Delicious" />
                        <h2>Indian Delicious</h2>
                    </div>
                    <div className="indian-menu mt-5 mb-5">
                        {indian.map(item => (
                            <Link to={`/menu-item/${item.id}`} key={item.id} className="food-item">
                                <img src={item.image} alt={item.name} className="food-image" />
                                <div className="item-info mt-4">
                                    <h3>{item.name}</h3>
                                </div>
                                <p id='desc'>{item.description}</p>
                            </Link>
                        ))}
                    </div>
                </div>

                <div ref={refs['vegetarian-specialties']} className='vegatrian-speciliciiest'>
                    <div className="image-container1">
                        <div className="overlay1"></div>
                        <img src="../images/veg/veg-bg.webp" alt="Vegetarian Specialties" />
                        <h2>Vegetarian Specialties</h2>
                    </div>
                    <div className="vegetrian-menu mt-5 mb-5">
                        {veg.map(item => (
                            <Link to={`/menu-item/${item.id}`} key={item.id} className="food-item">
                                <img src={item.image} alt={item.name} className="food-image" />
                                <div className="item-info mt-4">
                                    <h3>{item.name}</h3>
                                </div>
                                <p id='desc'>{item.description}</p>
                            </Link>
                        ))}
                    </div>
                </div>

                <div className='button-more mb-3'>
                    <p>Not found your dish here. Contact Us Directly <br />
                     Call at : +91 884-7026594, +91 73888 48178 </p>

                </div>

            </div>
        </>
    );
};

export default OurMenus;
